import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl'
import { each } from 'lodash'

import { callApi } from '../services/fetchService'
import { getSelectOptions } from '../services/selectService'
import { loadGlobals } from '../actions'

import FaIcon from '../components/FaIcon'
import DataTable from '../components/DataTable'
import TableButton from '../components/TableButton'
import { Button, Modal, Form, Input, Select, message } from 'antd'
const FormItem = Form.Item



class _LaboratoryModal extends Component {
    
    handleOk = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onOk(values).then(this.props.form.resetFields)
            }
        })
    }

    handleCancel = () => {
        this.props.form.resetFields()
        this.props.onCancel()
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { intl, item } = this.props

        return (
            <Modal title={<FormattedMessage id={"settings.laboratories." + (item ? 'update' : 'add')} />} visible={this.props.visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                <Form layout="vertical">
                    <FormItem label={<FormattedMessage id="settings.laboratories.valueColumn" />}>
                        {getFieldDecorator('value', {
                            initialValue: item ? item.value : null,
                            rules: [
                                {required: true, message: intl.formatMessage({id: 'settings.laboratories.nameRequired'})}
                            ]
                        })(<Input />)}
                    </FormItem>
                    <FormItem label={<FormattedMessage id="settings.laboratories.keyColumn" />}>
                        {getFieldDecorator('key', {
                            initialValue: item ? item.key : null,
                            rules: [
                                {required: true, message: intl.formatMessage({id: 'settings.laboratories.keyRequired'})}
                            ]
                        })(<Input disabled={item !== null} />)}
                    </FormItem>
                    <FormItem label={<FormattedMessage id="settings.laboratories.countryColumn" />}>
                        {getFieldDecorator('country', {
                            initialValue: item ? item.data.country : null,
                            rules: [
                                {required: true, message: intl.formatMessage({id: 'settings.laboratories.countryRequired'})}
                            ]
                        })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getSelectOptions('country', item ? item.data.country : null)}
                        </Select>)}
                    </FormItem>
                </Form>
            </Modal>
        )
    }
}

const LaboratoryModal = injectIntl(Form.create()(_LaboratoryModal))


class SettingsLaboratories extends Component {

    state = {
        data: [],
        loading: false,
        modalVisible: false,
        modalItem: null
    }

    static propTypes = {
        loadGlobals: PropTypes.func.isRequired,
        comboboxes: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'settings/laboratory'
        }).then((data) => {
            this.setState({
                data: each(data, (item) => {
                    item.editable = false
                    item.displayCountry = comboboxes.byKey.country[item.data.country].value
                }),
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    delete = (setting) => {
        const { intl, loadGlobals } = this.props
        callApi({
            endpoint: 'settings/laboratory/' + setting.id,
            method: 'DELETE'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.deleteSuccess'}))
            this.fetch()
            loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    /**
     * Modal handling
     */
    showModal = (laboratory) => {
        if (!laboratory || laboratory.id === undefined) {
            laboratory = null
        }
        this.setState({modalVisible: true, modalItem: laboratory})
    }
    cancelModal = () => {
        this.setState({modalVisible: false, modalItem: null})
    }
    okModal = (laboratory) => {
        const { intl, loadGlobals } = this.props
        laboratory.name = 'laboratory'
        laboratory.data = { country: laboratory.country }
        delete laboratory.country
        // Update
        if (this.state.modalItem) {
            laboratory.id = this.state.modalItem.id
            return callApi({
                endpoint: 'settings/laboratory/' + laboratory.id,
                method: 'POST',
                body: laboratory
            }).then((data) => {
                message.success(intl.formatMessage({id: 'misc.updateSuccess'}))
                this.setState({modalVisible: false})
                this.fetch()
                loadGlobals()
            }).catch((data) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                return Promise.reject()
            })
        }
        // Insert
        else {
            return callApi({
                endpoint: 'settings/laboratory',
                method: 'PUT',
                body: laboratory
            }).then((data) => {
                message.success(intl.formatMessage({id: 'misc.insertSuccess'}))
                this.setState({modalVisible: false})
                this.fetch()
                loadGlobals()
            }).catch((data) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                return Promise.reject()
            })
        }
    }

    /**
     * Render view
     */
    render() {
        const { data, loading, modalVisible, modalItem } = this.state

        const columns = [
            { title: "settings.laboratories.valueColumn", dataIndex: "value", type: "string", sorter: true },
            { title: "settings.laboratories.countryColumn", dataIndex: "displayCountry", type: "string", sorter: true },
            { title: "settings.laboratories.keyColumn", dataIndex: "key", type: "string", sorter: true },
            { title: "misc.actions", width: "100px", key: "action", render: (record) => (
                <span>
                    <TableButton color="blue" icon="pencil" onClick={this.showModal} value={record} />
                    <TableButton color="red" icon="trash-alt" onClick={this.delete} value={record} confirm />
                </span>
            ) }
        ]

        return (
            <div>
                <h1><FaIcon icon="cogs" fixedWidth /> <FormattedHTMLMessage id="settings.laboratories.title" /></h1>
                <div className="action-bar"><Button onClick={this.showModal}><FaIcon icon="plus"/> <FormattedMessage id="settings.laboratories.add" /></Button></div>
                <LaboratoryModal visible={modalVisible} item={modalItem} onOk={this.okModal} onCancel={this.cancelModal} />
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default injectIntl(connect(mapStateToProps, {
    loadGlobals
})(SettingsLaboratories))


// WEBPACK FOOTER //
// ./src/views/SettingsLaboratories.js